import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define the interface for your state
export interface WithdrawalsState {
  completedWithdrawTotal: number;
  pendingReviewWithdrawTotal: number;
  hasPendingReview: boolean;
}

export const createInitialWithdrawalsState = (): WithdrawalsState => ({
  completedWithdrawTotal: 0,
  pendingReviewWithdrawTotal: 0,
  hasPendingReview: false,
});

// Function to save the state to localStorage
const saveStateToLocalStorage = (state: WithdrawalsState) => {
  localStorage.setItem("withdrawalsState", JSON.stringify(state));
};

const withdrawalsSlice = createSlice({
  name: "withdrawals",
  initialState: createInitialWithdrawalsState(),
  reducers: {
    setCompletedWithdrawTotal: (state, action: PayloadAction<number>) => {
      state.completedWithdrawTotal = action.payload;
      saveStateToLocalStorage(state); // Persist to localStorage
    },
    setPendingReviewWithdrawTotal: (state, action: PayloadAction<number>) => {
      state.pendingReviewWithdrawTotal = action.payload;
      saveStateToLocalStorage(state); // Persist to localStorage
    },
    setHasPendingReview: (state, action: PayloadAction<boolean>) => {
      state.hasPendingReview = action.payload;
      saveStateToLocalStorage(state); // Persist to localStorage
    },
    clearWithdrawals: () => {
      localStorage.removeItem("withdrawalsState");
      return createInitialWithdrawalsState();
    },
  },
});

export const {
  setCompletedWithdrawTotal,
  setPendingReviewWithdrawTotal,
  setHasPendingReview,
  clearWithdrawals,
} = withdrawalsSlice.actions;

export default withdrawalsSlice.reducer;
